import { render } from "./QRCodeLogo.vue?vue&type=template&id=35916fc6"
const script = {}

import exportComponent from "/codebuild/output/src2531651810/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__